import React from 'react';
import { Poppins, Spacer } from 'src/common';
import Input from 'src/components/form/Input';
import Radio from 'src/components/form/Radio';
import { ActionsConf } from 'src/components/pdf/types';
import styled from 'styled-components';

const Div = styled.div`
  .radio-row {
    display: flex;
    align-items: center;
    grid-gap: 11px;
    margin-bottom: 11px;
    user-select: none;
  }
`;

interface ActionsExportFormProps {
  includesActions: ActionsConf;
  setIncludesActions: (includesActions: ActionsConf) => void;
}

export const ActionsExportForm: React.FC<ActionsExportFormProps> = ({ includesActions, setIncludesActions }) => {
  return (
    <Div>
      <div className="scenarios-switch">
        <Poppins className="subtitle scenarios-switch__title" style={{ width: 300 }}>
          Include the Actions for this assessment in your export?
        </Poppins>
        <div className="scenarios-switch__switch">
          <span>No</span>
          <Input
            checked={includesActions.enabled}
            onChange={(e) => setIncludesActions({ ...includesActions, enabled: e.target.checked })}
            className="switch"
            type="checkbox"
            data-cy="checkbox-actions"
          />
          <span>Yes</span>
        </div>
      </div>
      {includesActions.enabled && (
        <>
          <Spacer $px={15} />
          <Poppins className="subtitle">Filter actions by completion status:</Poppins>
          <Spacer $px={12} />
          <div
            className="radio-row"
            onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'ALL' })}
          >
            <Radio
              medium
              isChecked={includesActions.completionStatus !== 'ALL'}
              onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'ALL' })}
              dataCy="radio-all"
            />
            <Poppins className="checklist__row__label">All Actions</Poppins>
          </div>
          <div
            className="radio-row"
            onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'COMPLETED' })}
          >
            <Radio
              medium
              isChecked={includesActions.completionStatus !== 'COMPLETED'}
              onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'COMPLETED' })}
              dataCy="radio-completed"
            />
            <Poppins className="checklist__row__label">Completed Actions</Poppins>
          </div>
          <div
            className="radio-row"
            onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'INCOMPLETED' })}
          >
            <Radio
              medium
              isChecked={includesActions.completionStatus !== 'INCOMPLETED'}
              onClick={() => setIncludesActions({ ...includesActions, completionStatus: 'INCOMPLETED' })}
              dataCy="radio-incompleted"
            />
            <Poppins className="checklist__row__label">Incomplete Actions</Poppins>
          </div>
        </>
      )}
    </Div>
  );
};
